function NightAuditRevReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">NightAuditRevReport</div>
      </>
    );
  }
  
  export default NightAuditRevReport;